module.exports = __webpack_public_path__ + "static/img/pitch_blue_vertical.3dcab2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_blue_vertical.png
// module id = KXn4
// module chunks = 79